import { Moon, Sun, Monitor } from 'lucide-react'

const THEME_MODES = ['light', 'system', 'dark']
const THEME_ICONS = { light: Sun, system: Monitor, dark: Moon }
const THEME_LABELS = { light: 'Light', system: 'System', dark: 'Dark' }

const TopBar = ({ themeMode, setThemeMode, darkMode, title }) => {
  const cycleTheme = () => {
    const idx = THEME_MODES.indexOf(themeMode || 'system')
    const next = THEME_MODES[(idx + 1) % THEME_MODES.length]
    setThemeMode(next)
  }

  const mode = themeMode || (darkMode ? 'dark' : 'light')
  const Icon = THEME_ICONS[mode] || Monitor

  return (
    <header className="h-16 border-b border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-950 flex items-center justify-between px-4 sm:px-6">
      <h1 className="text-lg sm:text-xl font-bold text-gray-800 dark:text-white truncate">{title}</h1>
      <button
        onClick={cycleTheme}
        className="p-2 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500"
        aria-label={`Theme: ${THEME_LABELS[mode]}. Click to cycle.`}
        title={`Theme: ${THEME_LABELS[mode]}`}
      >
        <Icon className={`w-5 h-5 ${mode === 'light' ? 'text-amber-500' : mode === 'dark' ? 'text-blue-400' : 'text-gray-500 dark:text-gray-400'}`} />
      </button>
    </header>
  )
}

export default TopBar
